import React, { useMemo, useState } from "react";
import "./DeepInsightsConnectors.css";

// assets
import searchIcon from "../../assets/new-images/search-icon.svg";
import askIcon from "../../assets/new-images/connector-ask-icon.svg";
import infoIcon from "../../assets/images/red-info.svg";

// constants
import { useConstants } from "../../constant/constantProvider";

const DeepInsightsConnectors = ({
  connectors = [],
  isLoading = false,
  onAsk,
}) => {
  const { deepInsights } = useConstants();
  const [searchTerm, setSearchTerm] = useState("");

  const filteredConnectors = useMemo(() => {
    const query = searchTerm.trim().toLocaleLowerCase();
    if (!query) return connectors;

    return connectors.filter((connector) =>
      [connector.name, connector.category, connector.description]
        .filter(Boolean)
        .join(" ")
        .toLocaleLowerCase()
        .includes(query)
    );
  }, [connectors, searchTerm]);

  return (
    <section
      className="deep-insights-connectors"
      aria-labelledby="deep-insights-connectors-title"
    >
      <header className="deep-insights-connectors-header">
        <h1
          id="deep-insights-connectors-title"
          className="deep-insights-connectors-title"
        >
          {deepInsights.CONNECTORS_TITLE}
        </h1>
        <p className="deep-insights-connectors-description">
          {deepInsights.CONNECTORS_DESCRIPTION}
        </p>
      </header>

      <div className="deep-insights-connectors-search">
        <img src={searchIcon} alt="" aria-hidden="true" />
        <input
          type="search"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          placeholder={deepInsights.CONNECTORS_SEARCH_PLACEHOLDER}
          aria-label={deepInsights.CONNECTORS_SEARCH_ARIA_LABEL}
        />
      </div>

      <div className="deep-insights-connectors-info">
        <img src={infoIcon} alt="" aria-hidden="true" />
        <span>
          {deepInsights.CONNECTORS_INFO_INTRO}{" "}
          <strong>{deepInsights.CONNECTORS_INFO_AUTO_LABEL}</strong>{" "}
          {deepInsights.CONNECTORS_INFO_AUTO_DESCRIPTION}{" "}
          {deepInsights.CONNECTORS_INFO_MISSING}{" "}
          <span className="deep-insights-connectors-request">
            {deepInsights.CONNECTORS_REQUEST}
          </span>
        </span>
      </div>

      {isLoading ? (
        <div className="deep-insights-connectors-state" role="status">
          {deepInsights.CONNECTORS_LOADING}
        </div>
      ) : filteredConnectors.length === 0 ? (
        <div className="deep-insights-connectors-state">
          {connectors.length === 0
            ? deepInsights.CONNECTORS_EMPTY
            : deepInsights.CONNECTORS_NO_RESULTS}
        </div>
      ) : (
        <div className="deep-insights-connectors-grid">
          {filteredConnectors.map((connector) => (
            <article className="deep-insights-connector-card" key={connector.id}>
              <div className="deep-insights-connector-card-header">
                <span className="deep-insights-connector-icon">
                  {connector.icon_base64 && (
                    <img src={connector.icon_base64} alt="" aria-hidden="true" />
                  )}
                </span>
                <span className="deep-insights-connector-heading">
                  <h2>{connector.name}</h2>
                </span>
              </div>

              <p className="deep-insights-connector-description">
                {connector.description}
              </p>

              <div className="deep-insights-connector-actions">
                <span
                  className="deep-insights-connector-auto"
                  role="switch"
                  aria-checked="true"
                  aria-disabled="true"
                >
                  <span
                    className="deep-insights-connector-switch is-on"
                    aria-hidden="true"
                  />
                  {deepInsights.CONNECTORS_IN_AUTO}
                </span>
                <button
                  type="button"
                  className="deep-insights-connector-ask"
                  onClick={() => onAsk?.(connector.id)}
                >
                  <img src={askIcon} alt="" aria-hidden="true" />
                  {deepInsights.CONNECTORS_ASK}
                </button>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default DeepInsightsConnectors;
